<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="超级攻击配置" @back="goBack" /></span>
        </div>
        <el-form>
          <el-form-item label-width="120px" label="攻击次数：" prop="username">
            <el-input-number v-model="formData.attackNums" :controls="false" placeholder="请输入攻击次数" clearable size="small" style="width: 160px" />
          </el-form-item>
          <el-form-item label-width="120px" label="每次攻击次数：" prop="username">
            <el-input-number v-model="formData.shootRate" :controls="false" :max="5" placeholder="请输入每次攻击次数" clearable size="small" style="width: 160px" />
          </el-form-item>
        </el-form>
        <el-button v-permisaction="['config:RewardSuperBombEdit:save']" :disabled="isOnline === 1" type="primary" @click="onSubmit()">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import {
  getActivtyStageRewardCfg,
  updateActivtyStageRewardCfg
} from '@/api/config/activity-cfg'

export default {
  name: 'RewardSuperBombEdit',
  data() {
    return {
      isOnline: 0,
      aid: 0,
      type: '',
      defaultData: {
        attackNums: 3,
        shootRate: 2,
        robotConf: {
          useShieldPet: [60, 20, 10, 10, 0],
          shieldNums: [90, 10, 0, 0, 0] },
        minFloorAttack: 5,
        maxFloorAttack: 10
      },
      formData: {}
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.type = this.$route.query.type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.getTables()
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    handleClose(done, levelName, scoreName, index) {
      this.drawer[levelName][scoreName][index].visible = false
    },
    onSubmit() {
      const postData = { type: this.type, aid: this.aid, reward: this.formData }
      updateActivtyStageRewardCfg({ data: JSON.stringify(postData) }).then(res => {
        this.msgSuccess(res.msg)
        this.getTables()
      })
    },
    getTables() {
      this.formData = []
      getActivtyStageRewardCfg({ id: this.aid }).then(res => {
        if (!res.data.reward) {
          this.formData = this.defaultData
        } else {
          this.formData = res.data.reward
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
